import { makeStyles } from '@material-ui/core/styles';
import { mdiCog } from '@mdi/js';
import Icon from '@mdi/react';
import HeaderButton from 'components/layouts/components/Header/HeaderButton';
import P from 'router/paths';
import React from 'react';
import { useHistory } from 'react-router-dom';

const HelpMenu = () => {
  const classes = useStyles();
  const history = useHistory();

  const handleClick = (event) => {
    history.push(P.PROFILE.SETTINGS.USER);
  };

  return (
    <HeaderButton color='darkText' className={classes.container} onClick={handleClick}>
      <Icon path={mdiCog} />
    </HeaderButton>
  );
};

export default HelpMenu;

const useStyles = makeStyles((theme) => ({
  profileMenu: {
    marginTop: theme.spacing(),
    padding: 0,
  },
  menuItem: {
    textDecoration: 'none',
    padding: theme.spacing(1, 2),
    color: theme.colors.darkText,
    fontSize: 14,
    fontFamily: 'fregular',
    fontWeight: 500,
    minWidth: '20ch',
    borderBottom: `1px solid ${theme.colors.xlight}`,
    '& svg': {
      marginRight: theme.spacing(),
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
